export default "__VITE_ASSET__CNwB1f43__"